<template>
  <div>
    <v-container fluid class="d-print-none">
      <v-row no-gutters>
        <v-col cols="12">
          <h1 class="headline font-weight-light mb-3">UEFI</h1>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :items="data_main"
            :headers="headers"
            :items-per-page="10"
            :loading="isLoading"
            :search="search"
            loading-text="Loading... Please wait"
          >
            <template v-slot:item.no="{ item }">
              <span>
                {{
                  data_main
                    .map(function(x) {
                      return x.case_id;
                    })
                    .indexOf(item.case_id) + 1
                }}
              </span>
            </template>
            <template v-slot:item.case_id="{ item }">
              <v-btn rounded small @click="change_uefi(item.part_issue_id)">
                {{ item.case_id }}</v-btn
              >
            </template>
          </v-data-table>
        </v-card>

        <!-- <div class="text-center pb-5 pt-4 mar-t-20">
          <div>
            <v-btn
              class="mx-2"
              fab
              small
              @click="back()"
              :disabled="current_page <= 1"
            >
              <v-icon dark>mdi-chevron-left</v-icon>
            </v-btn>

            <v-btn
              class="mx-2"
              fab
              small
              :color="btn_color(n)"
              v-for="n in page_count"
              :key="n"
              @click="get_page(page_num_show(n))"
            >
              {{ page_num_show(n) }}
            </v-btn>

            <v-btn
              class="mx-2"
              fab
              small
              @click="next()"
              :disabled="page_count === current_page"
            >
              <v-icon dark>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div> -->
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-form method="post" id="nativeForm" v-model="valid">
        <v-dialog v-model="dialog" scrollable max-width="600px">
          <v-card>
            <v-card-title>UEFI</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="mar-t-20">
                <v-col cols="12">
                  <v-radio-group v-model="dialog" row>
                    <v-radio-group
                      v-model="form.uefi"
                      :rules="uefiR"
                      required
                      row
                    >
                      <v-radio label="มี UEFI" value="Y"></v-radio>
                      <v-radio label="ไม่มี UEFI" value="N"></v-radio>
                    </v-radio-group>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" class="mar-t-30">
                  <v-text-field
                    v-if="form.uefi === 'Y'"
                    dense
                    label="ระบุ UEFI"
                    v-model="form.uefi_text"
                    :maxlength="27"
                    :counter="27"
                    @keyup="checkuefi_text()"
                    :rules="uefi_textR"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-if="form.uefi === 'N'"
                    dense
                    label="ระบุเหตุผล"
                    v-model="form.uefi_text"
                    :rules="uefi_textRR"
                    required
                  ></v-text-field>
                  <div
                    id="my-strictly-unique-vue-upload-multiple-image"
                    style="text-align: center;"
                  >
                    <vue-upload-multiple-image
                      @upload-success="uploadImageSuccess"
                      @before-remove="beforeRemove"
                      @edit-image="editImage"
                      @data-change="dataChange"
                      dragText="UPLOAD"
                      browseText="Upload"
                      primaryText="Upload image"
                      markIsPrimaryText="จัดลำดับรูปภาพ"
                      idUpload="myIdUpload"
                      editUpload="myIdEdit"
                      :data-images="form.img"
                      :maxImage="20"
                    ></vue-upload-multiple-image>
                  </div>
                  <v-row>
                    <v-col
                      cols="6"
                      sm="4"
                      md="3"
                      lg="2"
                      v-for="(pic, num_pic) in data_img"
                      :key="num_pic"
                    >
                      <div class="images" v-viewer="{ movable: false }">
                        <div>
                          <img :src="url_pic + pic.file_id" class="image-cso" />
                          <v-btn
                            fab
                            color="red accent-2"
                            class="image-cso-btn"
                            x-small
                            @click="del_img(pic.file_id, num_pic)"
                          >
                            <v-icon>mdi-delete-forever</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-progress-linear
                    v-if="load === true"
                    indeterminate
                    color="cyan"
                  ></v-progress-linear>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                class="mr-5"
                small
                rounded
                :disabled="!valid"
                @click="save_uefi()"
              >
                <v-icon small class="mr-1">mdi-content-save</v-icon>
                Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
    </v-row>

    <div id="snackbar" class="d-print-none">
      <v-snackbar v-model="snackbar" color="success" right>
        {{ text }}
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations } from "vuex";
import VueUploadMultipleImage from "vue-upload-multiple-image";
const url = `${process.env.VUE_APP_ROOT_API}/api/`;

export default {
  components: {
    VueUploadMultipleImage,
  },
  computed: {
    ...mapState(["snackbar"]),
    ...mapState(["isLoading"]),
  },
  beforeMount() {
    this.tk = {
      headers: { Authorization: "Bearer " + localStorage.token },
    };
  },
  mounted() {
    this.get_data();
  },
  methods: {
    ...mapMutations(["mutatesnackbar"]),
    ...mapMutations(["mutateIsLoading"]),
    change_img(img, names, maincase_id, subcase) {
      this.form.maincase_id = maincase_id;
      this.form.subcase = subcase;
      this.active_img = names;
      this.data_img = img;
      this.dialog = true;
    },

    dataChange() {},
    beforeRemove(index, done, fileList) {
      var r = confirm("remove image");
      if (r == true) {
        done();
      } else {
      }
    },
    editImage(formData, index, fileList) {},
    uploadImageSuccess(formData, index, fileList) {
      this.form.img = fileList;
    },
    del_img(id, num_pic) {
      this.$swal({
        title: "ต้องการลบรูป " + this.active_img + " ใช้หรือไม่",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((del) => {
        if (del) {
          axios
            .delete(url + "case/attachments/" + id)
            .then((response) => {
              this.data_img = this.data_img.filter(
                (item) => item !== this.data_img[num_pic]
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },

    async get_data() {
      this.mutateIsLoading();

      await axios.get(url + "uefi", this.tk).then((response) => {
        this.data_main = response.data;
        this.mutateIsLoading();
      });
    },
    async back() {
      if (this.current_page > 1) {
        this.current_page--;
      }
      this.mutateIsLoading();
      let url = this.data_main.prev_page_url;
      await axios
        .get(url, this.tk)
        .then((response) => {
          this.data_main = response.data;
          this.mutateIsLoading();
        })
        .catch(function(error) {
          this.mutateIsLoading();
          console.log(error);
        });
    },
    async next() {
      this.mutateIsLoading();
      this.current_page++;
      let url = this.data_main.next_page_url;
      await axios
        .get(url, this.tk)
        .then((response) => {
          this.data_main = response.data;
          this.mutateIsLoading();
        })
        .catch(function(error) {
          this.mutateIsLoading();
          console.log(error);
        });
    },
    async get_page(num) {
      this.current_page = num;
      if (num != "...") {
        this.mutateIsLoading();
        await axios.get(url + "uefi?page=" + num, this.tk).then((response) => {
          this.data_main = response.data;
          this.mutateIsLoading();
        });
      }
    },
    btn_color(n) {
      if (this.page_count == 7) {
        if (this.data_main.current_page <= 4) {
          return this.data_main.current_page === n ? "primary" : "";
        } else if (this.data_main.current_page == this.data_main.last_page) {
          return n === 7 ? "primary" : "";
        } else if (
          this.data_main.current_page ==
          this.data_main.last_page - 1
        ) {
          return n === 6 ? "primary" : "";
        } else if (
          this.data_main.current_page ==
          this.data_main.last_page - 2
        ) {
          return n === 5 ? "primary" : "";
        } else {
          return n === 4 ? "primary" : "";
        }
      } else {
        return this.data_main.current_page === n ? "primary" : "";
      }
    },
    page_num_show(n) {
      let page = n;
      if (this.page_count == 7) {
        let chk2 = 0;
        let chk3 = 0;
        let chk4 = 0;
        let chk5 = 0;
        let chk6 = 0;
        if (this.data_main.current_page == 1) {
          chk2 = 2;
          chk3 = 3;
          chk4 = 4;
          chk5 = "...";
          chk6 = this.data_main.last_page - 1;
        } else if (this.data_main.current_page == this.data_main.last_page) {
          chk2 = 2;
          chk3 = "...";
          chk4 = this.data_main.last_page - 3;
          chk5 = this.data_main.last_page - 2;
          chk6 = this.data_main.last_page - 1;
        } else if (this.data_main.current_page == 2) {
          chk2 = 2;
          chk3 = 3;
          chk4 = 4;
          chk5 = "...";
          chk6 = this.data_main.last_page - 1;
        } else if (
          this.data_main.current_page ==
          this.data_main.last_page - 1
        ) {
          chk2 = 2;
          chk3 = "...";
          chk4 = this.data_main.last_page - 3;
          chk5 = this.data_main.last_page - 2;
          chk6 = this.data_main.last_page - 1;
        } else if (this.data_main.current_page == 3) {
          chk2 = 2;
          chk3 = 3;
          chk4 = 4;
          chk5 = "...";
          chk6 = this.data_main.last_page - 1;
        } else if (
          this.data_main.current_page ==
          this.data_main.last_page - 2
        ) {
          chk2 = 2;
          chk3 = "...";
          chk4 = this.data_main.last_page - 3;
          chk5 = this.data_main.last_page - 2;
          chk6 = this.data_main.last_page - 1;
        } else {
          chk2 = "...";
          chk3 = this.data_main.current_page - 1;
          chk4 = this.data_main.current_page;
          chk5 = this.data_main.current_page + 1;
          chk6 = "...";
        }

        n === 1 ? (page = 1) : "";
        n === 2 ? (page = chk2) : "";
        n === 3 ? (page = chk3) : "";
        n === 4 ? (page = chk4) : "";
        n === 5 ? (page = chk5) : "";
        n === 6 ? (page = chk6) : "";
        n === 7 ? (page = this.data_main.last_page) : "";
      } else {
        n === 1 ? (page = 1) : "";
        n === 2 ? (page = 2) : "";
        n === 3 ? (page = 3) : "";
        n === 4 ? (page = 4) : "";
        n === 5 ? (page = 5) : "";
        n === 6 ? (page = 6) : "";
      }
      return page;
    },
    change_uefi(part_issue_id) {
      this.part_issue_id = part_issue_id;
      this.dialog = true;
    },
    async checkuefi_text() {
      if (this.form.uefi === "Y" && this.form.uefi_text.length === 27) {
        this.load = true;
        await axios
          .post("https://eas-api.hpcloud.hp.com/v1/DecodeFailureIds/", {
            LanguageId: "en-US",
            FailureIds: [
              {
                FailureId: this.form.uefi_text,
              },
            ],
          })
          .then((response) => {
            this.load = false;
            if (response.data.DecodeFailureIds[0].Valid === false) {
              this.form.uefi_text = "";
              this.$swal("uefi invalid! Please try again.", {
                icon: "warning",
                button: false,
                timer: 2000,
              });
            } else if (response.data.DecodeFailureIds[0].Valid === true) {
              this.$swal("uefi Valid.", {
                icon: "success",
                button: false,
                timer: 2000,
              });
            }
          });
      }
    },
    async save_uefi() {
      this.mutateIsLoading();
      let formData = new FormData();
      formData.append("uefi", this.form.uefi);
      formData.append("uefi_text", this.form.uefi_text);
      for (let i = 0; i < this.form.img.length; i++) {
        formData.append("upload" + `[${i}]`, this.form.img[i].path);
      }
      //Save Img
      await axios
        .post(url + "uefi/" + this.part_issue_id, formData, this.tk)
        .then((response) => {
          this.mutatesnackbar();
          this.mutateIsLoading();
          this.close();
          this.get_data();
          setTimeout(() => {
            this.mutatesnackbar();
          }, 3000);
        })
        .catch(function(error) {
          console.log(error);
          // this.mutateIsLoading()
        });
      //
    },
    close() {
      this.dialog = false;
      this.form = { uefi: "", uefi_text: "", img: [] };
    },
  },
  data() {
    return {
      url_pic: `${process.env.VUE_APP_ROOT_API}/api/case/attachments/`,
      headers: [
        {
          text: "#",
          value: "no",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "Case ID",
          value: "case_id",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "Serial",
          value: "product_serial",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "Product",
          value: "product_no",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "Part",
          value: "part_name",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "Description",
          value: "part_description",
          class: "text-uppercase blue darken-3 white--text",
        },
      ],
      load: false,
      dialog: false,
      valid: false,
      tk: null,
      data_main: [],
      form: {
        uefi: "",
        uefi_text: "",
        img: [],
      },
      page: 1,
      page_total: 0,
      page_count: 0,
      current_page: 1,
      text: "Success, Your work has been saved",
      part_issue_id: 0,
      uefiR: [(v) => !!v || "UEFI Status is required"],
      uefi_textR: [
        (v) => !!v || "UEFI Text is required",
        (v) => v.length === 27 || "UEFI must be less than 27 characters",
      ],
      uefi_textRR: [(v) => !!v || "UEFI Remark  is required"],
      search: "",
      active_img: null,

      data_img: [],

      dialoguefi: false,
    };
  },
};
</script>
